import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { SpotflowService } from "@/services/Spotflow/spotflow";
import { useSpotUser } from "@/utils/spotUser";
import { DATA_KEYS } from "@/utils/useRemoteData";

const MODELS_STALE_MS = 5 * 60 * 1000;

// The model routes are rate limited per client IP, so the query keeps the
// app's retry policy (it waits out a 429) and every picker reading the same
// endpoint shares one cached list.
export const useModels = (endpoint: string, enabled = true) => {
  const { spotGroup } = useSpotUser();
  return useQuery({
    queryKey: [DATA_KEYS.MODELS, endpoint, spotGroup.id],
    queryFn: () => SpotflowService.getModels(endpoint, spotGroup.id),
    staleTime: MODELS_STALE_MS,
    enabled: enabled && Boolean(spotGroup.id),
  });
};

export const modelsErrorReason = (error: unknown): string | null => {
  if (!(error instanceof AxiosError) || !error.response) {
    return null;
  }
  const { status, statusText, data } = error.response;
  const detail =
    data && typeof data === "object" && typeof data.detail === "string"
      ? data.detail
      : statusText;
  return detail ? `${detail} (${status})` : `(${status})`;
};
